module.exports = "<main class=\"account-settings container-fluid\" cg-busy=\"{promise: vm.loadingPromises, message: 'Loading...', minDuration: 500}\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <div class=\"well\">\n        <p class=\"help-block\">\n        Please wait while your account link is processed.\n        If you are stuck here, <a ui-sref=\"settings.integrations\">return to the integrations page</a>.\n        </p>\n      </div>\n    </div>\n  </div>\n</main>\n"


//////////////////
// WEBPACK FOOTER
// ./app/pages/settings/twitter.html
// module id = 475
// module chunks = 3